module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/dce0642a958886ae60407ae110532f6a.jpg";